/**
* IBAN lengths for each country
*
* @var {Object}
*/
export const IBANLength = {
  'AD': 24,
  'AL': 28,
  'AT': 20,
  'BA': 20,
  'BE': 16,
  'BG': 22,
  'CH': 21,
  'CS': 22,
  'CY': 28,
  'CZ': 24,
  'DE': 22,
  'DK': 18,
  'EE': 20,
  'ES': 24,
  'FR': 27,
  'FI': 18,
  'GB': 22,
  'GI': 23,
  'GR': 27,
  'HR': 21,
  'HU': 28,
  'IE': 22,
  'IS': 26,
  'IT': 27,
  'LI': 21,
  'LU': 20,
  'LT': 20,
  'LV': 21,
  'MC': 27,
  'ME': 22,
  'MU': 30,
  'MK': 19,
  'MT': 31,
  'NC': 27,
  'NL': 18,
  'NO': 15,
  'PF': 27,
  'PL': 28,
  'PT': 25,
  'PM': 27,
  'RO': 24,
  'RS': 22,
  'SA': 24,
  'SE': 24,
  'SI': 19,
  'SK': 24,
  'SM': 27,
  'TF': 27,
  'TN': 24,
  'TR': 26,
  'YT': 27,
  'WF': 27,
  'QX': 34
}

/**
* IBAN patterns for each country
* (un IBAN s'ecrit differemment en fonction des pays)
* @var {Object}
*/
export const IBANPatterns = {
  'AE': /^AE\d{21}$/,
  'AL': /^AL\d{10}[0-9A-Z]{16}$/,
  'AD': /^AD\d{10}[0-9A-Z]{12}$/,
  'AT': /^AT\d{18}$/,
  'BH': /^BH\d{2}[A-Z]{4}[0-9A-Z]{14}$/,
  'BE': /^BE\d{14}$/,
  'BA': /^BA\d{18}$/,
  'BG': /^BG\d{2}[A-Z]{4}\d{6}[0-9A-Z]{8}$/,
  'CH': /^CH\d{7}[0-9A-Z]{12}$/,
  'HR': /^HR\d{19}$/,
  'CY': /^CY\d{10}[0-9A-Z]{16}$/,
  'CZ': /^CZ\d{22}$/,
  'DK': /^DK\d{16}$|^FO\d{16}$|^GL\d{16}$/,
  'DO': /^DO\d{2}[0-9A-Z]{4}\d{20}$/,
  'EE': /^EE\d{18}$/,
  'ES': /^ES\d{22}$/,
  'FI': /^FI\d{16}$/,
  'FR': /^FR\d{12}[0-9A-Z]{11}\d{2}$/,
  'GE': /^GE\d{2}[A-Z]{2}\d{16}$/,
  'DE': /^DE\d{20}$/,
  'GB': /^GB\d{2}[A-Z]{4}\d{14}$/,
  'GI': /^GI\d{2}[A-Z]{4}[0-9A-Z]{15}$/,
  'GR': /^GR\d{9}[0-9A-Z]{16}$/,
  'HU': /^HU\d{26}$/,
  'IS': /^IS\d{24}$/,
  'IE': /^IE\d{2}[A-Z]{4}\d{14}$/,
  'IL': /^IL\d{21}$/,
  'IT': /^IT\d{2}[A-Z]\d{10}[0-9A-Z]{12}$/,
  'KZ': /^[A-Z]{2}\d{5}[0-9A-Z]{13}$/,
  'KW': /^KW\d{2}[A-Z]{4}22!$/,
  'LV': /^LV\d{2}[A-Z]{4}[0-9A-Z]{13}$/,
  'LB': /^LB\d{6}[0-9A-Z]{20}$/,
  'LI': /^LI\d{7}[0-9A-Z]{12}$/,
  'LT': /^LT\d{18}$/,
  'LU': /^LU\d{5}[0-9A-Z]{13}$/,
  'MK': /^MK\d{5}[0-9A-Z]{10}\d{2}$/,
  'MT': /^MT\d{2}[A-Z]{4}\d{5}[0-9A-Z]{18}$/,
  'MR': /^MR13\d{23}$/,
  'MU': /^MU\d{2}[A-Z]{4}\d{19}[A-Z]{3}$/,
  'MC': /^MC\d{12}[0-9A-Z]{11}\d{2}$/,
  'ME': /^ME\d{20}$/,
  'NL': /^NL\d{2}[A-Z]{4}\d{10}$/,
  'NO': /^NO\d{13}$/,
  'PL': /^PL\d{10}[0-9A-Z]{,16}n$/,
  'PT': /^PT\d{23}$/,
  'RO': /^RO\d{2}[A-Z]{4}[0-9A-Z]{16}$/,
  'RS': /^RS\d{20}$/,
  'SA': /^SA\d{4}[0-9A-Z]{18}$/,
  'SE': /^SE\d{22}$/,
  'SI': /^SI\d{17}$/,
  'SK': /^SK\d{22}$/,
  'SM': /^SM\d{2}[A-Z]\d{10}[0-9A-Z]{12}$/,
  'TN': /^TN59\d{20}$/,
  'TR': /^TR\d{7}[0-9A-Z]{17}$/
}

/**
 * Validate an IBAN.
 *
 * @param {String}  key - the IBAN.
 *
 * @return {Boolean}
 */
export const validateIBAN = (key) => {
  if (!key || !IBANPatterns[key.substr(0, 2)]) {
    return false
  }
  return key.match(IBANPatterns[key.substr(0, 2)])
}

export const validateIBANRIBKey = (key) => {
  // Clé
  let format = []
  let ibanNumber = key.replace(/ /g, '').toUpperCase()
  ibanNumber = ibanNumber.replace(/^IBAN/, ' ibanNumber')
  format = ibanNumber.substr(4) + ibanNumber.substr(0, 4)
  let arrayrange = ['10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22',
    '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35']
  let arrayletter = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
  let newFormat = ''
  let curLetter, indexLetter, curNumber
  for (let i = 0; i < format.length; i++) {
    curLetter = format.charAt(i)
    indexLetter = arrayletter.indexOf(curLetter)
    if (indexLetter !== -1) {
      curNumber = arrayrange[indexLetter]
      newFormat += curNumber.toString()
    } else {
      newFormat += format.charAt(i)
    }
  }
  var tempround = newFormat.substr(0, 1)
  var temp = Math.round(tempround)
  var len = newFormat.length
  for (var pos = 1; pos < len; pos++) {
    temp = 10 * temp
    temp = Math.round(newFormat.substr(pos, 1)) + parseFloat(temp)
    temp %= 97
  }
  return temp === 1
}

export const validateAccountFormat = (key, regex) => {
  return key.match(regex)
}

export const validateABA = (key) => {
  return key.match(/^(\d{9})$/)
}

export const validateBSB = (key) => {
  return key.match(/^(\d{6})$/)
}

export const validateSortCode = (key) => {
  return key.match(/^(\d{1,6})$/)
}

export const validateAccountNumber = (key) => {
  return key.match(/^(\d{1,8})$/)
}

export const validateEmail = (key) => {
  return key.match(/^([\w.-]+)@([\w-]+)(\.([\w-]+))+$/)
}

export const validateCompanyNumber = (key, country) => {
  switch (country) {
    case 'UK':
      return key.match(/^([0-9]{8})$/)
    default:
      return key.match(/^([0-9]{9})$/)
  }
}

export const validateSIREN = (key) => {
  return key.match(/^([0-9]{9})$/)
}

export const validateSIRET = (key) => {
  return key.match(/^([0-9]{14})$/)
}

export const validatePhoneNumber = (key) => {
  return key.match(/^(?:\+\d{1,3}|0\d{1,3}|00\d{1,2})([0-9]{1,})$/)
}

export const validateEmailOrSIREN = (key) => {
  return key.match(/^([\w.-]{1,})@(\w{1,})(\.(\w{1,})){1,}$/) || key.match(/^([0-9]{9})$/)
}

export const validateMonthYearDate = (key) => {
  return key.match(/^\d{2}-\d{4}/)
}

// true if empty, false otherwise
export const isEmptyValue = (value) => {
  if (value === '' || value == null) {
    return true
  }
  return false
}

/** @author TLV 06/11/2020
* @brief Fonction pour vérifier les valeurs obligatoires dans un formulaire
* @details Les components <form-write-group-label-input> encapsulent un nouveau booléen
*         facultatif, appelé mandatoryErrorIndicator, pour indiquer une erreur si
*         un champ obligatoire n'a pas été rempli.
*         Les attributs associés doivent être de la forme "Nom de l'attribut" + "Error".
*         Par exemple, l'attribut associé à "recipientName" sera appelé "recipientNameError".
*         Cette syntaxe permet à la fonction verifyMandatoryValues() de
*         mettre à jour automatiquement ces attributs si besoin.
*/
export const verifyMandatoryValues = (mandatoryValues, flagsList, component) => {
  for (let i = 0; i < mandatoryValues.length; i++) {
    flagsList[mandatoryValues[i]] = isEmptyValue(component[mandatoryValues[i]])
    if (flagsList[mandatoryValues[i]]) {
      component[mandatoryValues[i] + 'Error'] = true
    } else {
      component[mandatoryValues[i] + 'Error'] = false
    }
  }
  return flagsList
}

/** @author TLV 06/11/2020
* @brief Fonction pour vérifier les expressions régulières dans un formulaire.
* @details  Les components <form-write-group-label-input> encapsulent un nouveau booléen
*         facultatif, appelé regexpErrorIndicator, pour indiquer une erreur si un
*         champ demandant une regexp n'est pas rempli avec une chaîne de caractères
*         respectant cette regexp.
*         Les attributs associés doivent être de la forme "Nom de l'attribut" + "RegexpError".
*         Par exemple, l'attribut associé à "recipientEmail" sera appelé "recipientEmailRegexpError".
*         Cette syntaxe permet à la fonction verifyRegexpValues de
*         mettre à jour automatiquement ces attributs si besoin.
*/
export const verifyRegexpValues = (regexpValues, flagsList, component) => {
  for (let valueToCheck in regexpValues) {
    if (!isEmptyValue(component[valueToCheck])) {
      switch (regexpValues[valueToCheck].toLowerCase()) {
        case 'email':
          flagsList[valueToCheck] = !validateEmail(component[valueToCheck])
          break
        case 'siren':
          flagsList[valueToCheck] = !validateSIREN(component[valueToCheck])
          break
        case 'siret':
          flagsList[valueToCheck] = !validateSIRET(component[valueToCheck])
          break
        case 'emailorsiren':
          flagsList[valueToCheck] = !validateEmailOrSIREN(component[valueToCheck])
          break
        case 'phonenumber':
          flagsList[valueToCheck] = !validatePhoneNumber(component[valueToCheck])
          break
        case 'accountnumber':
          flagsList[valueToCheck] = !validateAccountNumber(component[valueToCheck])
          break
        case 'sortcode':
          flagsList[valueToCheck] = !validateSortCode(component[valueToCheck])
          break
        case 'bsb':
          flagsList[valueToCheck] = !validateBSB(component[valueToCheck])
          break
        case 'aba':
          flagsList[valueToCheck] = !validateABA(component[valueToCheck])
          break
        case 'iban':
          flagsList[valueToCheck] = !validateIBAN(component[valueToCheck])
          break
        case 'monthyeardate':
          flagsList[valueToCheck] = !validateMonthYearDate(component[valueToCheck])
          break
        default:
          break
      }
      component[valueToCheck + 'RegexpError'] = flagsList[valueToCheck]
    }
  }
  return flagsList
}

/** @author TLV 30/11/2020
* @brief Fonction pour vérifier si les valeurs de intervalValues respectent bien les
*         intervalles de valeurs donnés.
* @details Fonctionnement analogue à la fonction verifyRegexpValues
*/
export const verifyIntervalValues = (intervalValues, flagsList, component) => {
  for (let valueToCheck in intervalValues) {
    if (!isEmptyValue(component[valueToCheck])) {
      if (!isEmptyValue(intervalValues[valueToCheck]['min']) && !isEmptyValue(intervalValues[valueToCheck]['max'])) {
        flagsList[valueToCheck] = (component[valueToCheck] < intervalValues[valueToCheck]['min'] ||
                                  component[valueToCheck] > intervalValues[valueToCheck]['max'])
      } else if (!isEmptyValue(intervalValues[valueToCheck]['min'])) {
        flagsList[valueToCheck] = (component[valueToCheck] < intervalValues[valueToCheck]['min'])
      } else {
        flagsList[valueToCheck] = (component[valueToCheck] > intervalValues[valueToCheck]['max'])
      }
    }
    component[valueToCheck + 'IntervalError'] = flagsList[valueToCheck]
  }
  return flagsList
}

/** @author TLV 06/11/2020
* @brief Fonction qui retourne true s'il y a une erreur dans le formulaire, false sinon
*/
export const checkErrorFlag = (flagsList) => {
  for (let attribute in flagsList) {
    if (flagsList[attribute]) {
      return true
    }
  }
  return false
}



// WEBPACK FOOTER //
// ./src/helpers/validator.js